"use client"
import { DeleteBlog, EditReviewOrBlog, getAllBlogs } from "@/API/response";
import { deleteBlog, getBlogSuccess, fetchingStart, updateBlog } from "@/GlobalRedux/getBlogSlice";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FetchingLoader from '@/components/SkeletonLoader/FetchingLoader';
import { FaRegTrashCan } from "react-icons/fa6";
import { ToastContainer, toast } from 'react-toastify';
import { FaRegEdit } from "react-icons/fa";
import { BlogEditModal } from "./BlogEditModal";
import CustomModal from "@/hooks/confirmationModal";
import BlogModal from "../Blogs/blogModal";
import { useRouter } from "next/navigation";
import { Logout } from "@/GlobalRedux/UserSlice";
import { errorNotify } from "@/hooks/toast";

export const HoverEffect = ({ className }) => {
  const route = '/blog/get';
  const dispatch = useDispatch();
  const router = useRouter()
  const GetBlogs = async () => {
    try {
      dispatch(fetchingStart())
      const response = await getAllBlogs(route);
      // console.log("response", response);
      if (response.status) {
        dispatch(getBlogSuccess(response.data));
      }
      else {
        dispatch(getBlogSuccess([]));
      }
    } catch (error) {
      console.log("Full error:", error);

      if (error.response) {
        console.log("Server Error:", error.response.data);
      } else if (error.request) {
        console.log("No response from server");
      } else {
        console.log("Error:", error.message);
      }
      dispatch(getBlogSuccess([]));
    }
  };

  const { getblogs, isloader } = useSelector((state) => state.blogs);
  const { users } = useSelector((state) => state.user);
  const adminToken = users?.token
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [DeleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [singleBlog, setSingleBlog] = useState([])

  // edit function open modal
  const handleOpenModal = (id) => {
    getSingleBlog(id)
    setIsModalOpen(true);
  };

  // Edit Blog API function
  const handleUpdateData = async (updatedData) => {
    const response = await EditReviewOrBlog(`/blog/update/${singleBlog?._id}`, adminToken, updatedData)
    if (response.message == "In Valid Token") {
      errorNotify("Session expired.  Please Login")
      router.push("/login")
      dispatch(Logout())
    }
    else if (response) {
      dispatch(updateBlog(response.data));
      setSingleBlog(updatedData);
    }
    setSingleBlog(updatedData);
  };
  // get single blog API function
  const getSingleBlog = async (id) => {
    const response = await getAllBlogs(`/blog/${id}`)
    if (response?.status) {

      setSingleBlog(response.data)
    }
    else {
      setSingleBlog([])
    }
  }
  // close  edit modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  // delete modal or function work
  // delete function open modal
  const handleOpenDelModal = (id) => {
    setSelectedId(id)
    setDeleteModal(true);
  };

  // DELETE  Blog API function
  const deleteBlogFunc = async () => {
    const response = await DeleteBlog(`/blog/delete/${selectedId}`, adminToken)
    if (response.message == "In Valid Token") {
      errorNotify("Session expired.  Please Login")
      router.push("/login")
      dispatch(Logout())
    }
    dispatch(deleteBlog(selectedId))
    closeDelModal()
  }
  // close  DELETE modal

  const closeDelModal = () => {
    setDeleteModal(false)
    setSelectedId(null);
  }
  // see more option on blog 

  const [OpenBlog, setOpenBlog] = useState(false);
  const ShowBlogOpen = (id) => {
    // console.log("id --->>>",id)
    setOpenBlog(true)
    getSingleBlog(id)
  }
  const closeBlogModal = () => {
    setOpenBlog(false)
  }

  // show blogs on load page 
  useEffect(() => {
    GetBlogs();
  }, []);

  return (
    <div className={cn("grid grid-cols-1 md:grid-cols-1  gap-4 lg:grid-cols-3 xl:grid-cols-3 py-10 overflow-x-hidden", className)}>
      {isloader ? (
        <div className="col-span-full flex items-center justify-center min-h-[40vh]">
          <FetchingLoader />
        </div>

      ) :
        getblogs.length === 0 ? (
          <div className="col-span-full flex items-center justify-center min-h-[40vh]">
            <h2 className="text-zinc-200 bg-gray-800/50 backdrop-blur-md px-6 py-4 rounded-xl font-semibold tracking-wide text-center shadow-md border border-gray-700">
              No Blogs Available
            </h2>
          </div>
        ) :
          (
            getblogs.map((item, idx) => (
              <Card key={idx} className={'w-full h-fit min-h-80'}>
                <span
                  className={users?.data.role === "Admin" ? "justify-between items-center flex" : "flex justify-center items-center"}
                >
                  <span>
                    <CardTitle className={'capitalize truncate-title'}>{item.title}</CardTitle>
                  </span>
                  {
                    isloader ? <FetchingLoader /> :
                      <>
                        <span className="flex justify-end gap-3">

                          <span className={users?.data.role === "Admin" ? "hover:cursor-pointer hover:text-blue-500 flex " : "hidden"}>
                            <FaRegEdit size={20} color="#fff" onClick={() => handleOpenModal(item._id)} />
                          </span>
                          <span className={users?.data.role === "Admin" ? "hover:cursor-pointer  hover:text-red-500 flex " : "hidden"}>
                            <FaRegTrashCan size={20} color="#fff" onClick={() => handleOpenDelModal(item._id)} />
                          </span>
                        </span>
                      </>
                  }
                </span>

                <CardDescription className='truncate-description leading-relaxed text-justify'>{item.message} </CardDescription> <span className="text-blue-600 text-lg font-bold cursor-pointer" onClick={() => ShowBlogOpen(item._id)}>See more</span>
                <BlogEditModal
                  onSubmit={handleUpdateData} data={singleBlog} isOpen={isModalOpen} onClose={handleCloseModal} />
                <CustomModal openModal={DeleteModal} onSubmit={() => deleteBlogFunc(selectedId)} onClose={closeDelModal} />
                {singleBlog ? <BlogModal openModal={OpenBlog} data={singleBlog} onClose={closeBlogModal} /> : <FetchingLoader />}
              </Card>
            ))
          )}

      <ToastContainer />
    </div>
  );
};

export const Card = ({ className, children }) => {
  return (
    <div
      className={cn(
        "  rounded-2xl h-full w-full flex justify-center  p-4 overflow-hidden  relative z-20",
        // "card-premium rounded-2xl h-full w-full flex justify-center  p-4 overflow-hidden relative z-20",
        className
      )}
      style={{
        borderRadius: '1.25rem',
        border: '1px solid rgba(148, 163, 184, 0.12)',
        background: 'linear-gradient(180deg, rgba(30,41,59,0.55) 0%, rgba(15,23,42,0.65) 100%)',
        boxShadow: '0 1px 0 0 rgba(255,255,255,0.04) inset, 0 20px 40px -20px rgba(0,0,0,0.65)',
        transition: 'transform 300ms ease, box-shadow 300ms ease, border-color 300ms ease',
      }}
    >
      <div className="relative z-50">
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

export const CardTitle = ({ className, children }) => {
  return (
    <h4 className={cn("text-zinc-100 font-bold tracking-wide mt-4", className)}>
      {children}
    </h4>
  );
};

export const CardDescription = ({ className, children }) => {
  return (
    <p className={cn("mt-6 text-zinc-300 tracking-wide leading-relaxed text-md", className)}>
      {children}
    </p>
  );
};
